const FORM_STATUS = {
    NO_ACTION : 'NO_ACTION',
    CLOSE : 'CLOSE_ACTION',
    SAVE : 'SAVE_ACTION'
}

export {
    FORM_STATUS
}